export default __webpack_public_path__ + "static/media/menuCloseIcon.63b9ffc9.svg";